<form [formGroup]="form" class="main-grid">
  <div class="metadata-field" *permissions="[Permissions.WRITE_REFERENCE_ID]">
    <mat-form-field color="accent">
      <mat-label>Semeris Internal Reference #</mat-label>
      <input matInput formControlName="referenceNumber" autocomplete="off" />
    </mat-form-field>
  </div>

  @if (hasIntegrationIdentifier()) {
    <mat-form-field *permissions="[Permissions.WRITE_INTEGRATION_IDENTIFIER]" color="accent">
      <mat-label>Integration Identifier</mat-label>
      <input matInput formControlName="integrationIdentifier" copyTo="integrationIdentifier" autocomplete="off" />
      @if (form | formControlError: 'integrationIdentifier'; as error) {
        <mat-error>{{ error }}</mat-error>
      }
    </mat-form-field>
  }

  <mat-form-field color="accent">
    <mat-label>Name</mat-label>
    <input matInput formControlName="displayName" copyTo="displayName" autocomplete="off" />
  </mat-form-field>

  @if (hasDisplayShortName()) {
    <mat-form-field color="accent">
      <mat-label>Name (short version)</mat-label>
      <input matInput formControlName="displayShortName" autocomplete="off" copyTo="displayShortName" />
      <mat-hint align="end">Used in certain places where it is visually more useful.</mat-hint>
    </mat-form-field>
  }

  <mat-form-field color="accent">
    <mat-label>Use with asset class(es)</mat-label>
    <semeris-ng-select
      class="asset-select"
      formControlName="assetShortNames"
      [multiple]="true"
      [options]="assets()"
      [required]="true"
    ></semeris-ng-select>
    @if (form | formControlError: 'assetShortNames'; as error) {
      <mat-error>{{ error }}</mat-error>
    }
  </mat-form-field>

  <mat-form-field color="accent" class="double-cell">
    <mat-label>Description</mat-label>
    <textarea rows="7" matInput formControlName="description" autocomplete="off" copyTo="description"> </textarea>
  </mat-form-field>

  @if (type() === TemplateModalType.RuleBase) {
    <ng-container *permissions="[Permissions.WRITE_DATAPOINT_META]">
      <div class="metadata-field">
        <mat-form-field color="accent">
          <mat-label>Analyst Contribution</mat-label>
          <semeris-ng-select formControlName="verificationType" [options]="VerificationTypeOptions"></semeris-ng-select>
        </mat-form-field>
      </div>
      <mat-form-field color="accent">
        <mat-label>AI Contribution</mat-label>
        <semeris-ng-select formControlName="aiContribution" [options]="AIContributionOptions"></semeris-ng-select>
      </mat-form-field>
      @if (showPresentationType()) {
        <mat-form-field color="accent">
          <mat-label>Presentation</mat-label>
          <semeris-ng-select formControlName="presentationType" [options]="PresentationTypeOptions"></semeris-ng-select>
        </mat-form-field>
      }
      <ng-container *permissions="[Permissions.WRITE_DATAPOINT_GT]">
        @if (groundTruthAvailable()) {
          <mat-form-field color="accent">
            <mat-label>Ground Truth</mat-label>
            <semeris-ng-select
              formControlName="groundTruthDatapointField"
              [clearable]="true"
              [multiple]="false"
              bindValue="id"
              bindLabel="nameWithReference"
              [options]="datapointFieldOptions()"
            >
            </semeris-ng-select>
          </mat-form-field>
        }
      </ng-container>
    </ng-container>
    <mat-form-field *permissions="[Permissions.WRITE_DATAPOINT_META]" color="accent" class="double-cell">
      <mat-label>Details</mat-label>
      <textarea rows="7" matInput formControlName="details" autocomplete="off" copyTo="details"> </textarea>
    </mat-form-field>
    <ng-container *permissions="[Permissions.WRITE_DATAPOINT_META]">
      <mat-form-field color="accent" class="double-cell">
        <mat-label>Metadata - Value Description</mat-label>
        <textarea rows="7" matInput formControlName="metaValueDescription" autocomplete="off"> </textarea>
      </mat-form-field>
      <mat-form-field color="accent">
        <mat-label>Metadata - Example Value</mat-label>
        <input matInput formControlName="metaExample" autocomplete="off" />
      </mat-form-field>
      <mat-form-field color="accent" class="double-cell">
        <mat-label>Metadata - Value Issues</mat-label>
        <textarea rows="7" matInput formControlName="metaValueIssues" autocomplete="off"> </textarea>
      </mat-form-field>
    </ng-container>
    <ng-container *permissions="[Permissions.WRITE_DATAPOINT_META_STATS]">
      <div class="metadata-field">
        <mat-slide-toggle color="accent" formControlName="statsEnabled">Statistics - Enabled</mat-slide-toggle>
      </div>
      <mat-form-field color="accent" class="double-cell">
        <mat-label>Statistics - Numeric Transform Function</mat-label>
        <textarea rows="7" matInput formControlName="statsNumericTransform" autocomplete="off"> </textarea>
      </mat-form-field>
      <div class="metadata-field">
        <mat-slide-toggle color="accent" formControlName="statsCalculateNumeric">Statistics - Calculate Numeric Value</mat-slide-toggle>
      </div>
    </ng-container>
    @if (showTtl()) {
      <mat-form-field color="accent">
        <mat-label>Expiration period</mat-label>
        <semeris-ng-select formControlName="ttlSeconds" [options]="TtlOptions" [clearable]="true"></semeris-ng-select>
      </mat-form-field>
    }
  }

  @if (type() === TemplateModalType.Normal) {
    <mat-form-field color="accent">
      <mat-label>Topic short name</mat-label>
      <input matInput formControlName="topicShortName" autocomplete="off" />
    </mat-form-field>
    <div class="metadata-field" *permissions="[Permissions.WRITE_CUSTOMIZE_BUILT_IN]">
      <mat-slide-toggle color="accent" formControlName="builtIn">Built-in</mat-slide-toggle>
    </div>
  }

  <semeris-user-entity-control-form
    [form]="form"
    [wideMode]="true"
    [canShare]="item()?.canShare"
    [canPublish]="item()?.canPublish"
    [canHide]="type() === TemplateModalType.RuleBase || type() === TemplateModalType.Formula"
    [publishDisabled]="publishDisabled$ | async"
    publishDisabledReason="Fill in the description in order to publish"
  ></semeris-user-entity-control-form>
</form>
